import { SET_USER_PREFERENCES } from '../actions/actionTypes';

export default function userPreferencesReducer(state = {}, action) {
  if (action.type === SET_USER_PREFERENCES) {
    return action.payload;
  } else {
    return state;
  }
}
